module.exports = __webpack_public_path__ + "static/media/image_40.15ad218b.png";